import { Route } from '@angular/router';

import { routeNames } from './../route-names';
import { User } from '../../models/user.model';
import { RoutesRules } from '../../interfaces/routes-rules';

export class PermissionHelper {
  // Use properties 'forbiddenRoles' or 'allowedRoles' to define user page access.
  // Use property 'forbiddenRoles' to deny access to user having those specifics roles :
  // { routepath: routeNames.home, forbiddenRoles: [RoleHelper.PARTNER] },
  // Use property 'allowedRoles' to give access only to user having those specifics roles :
  // { routepath: routeNames.home, allowedRoles: [RoleHelper.OWNER, RoleHelper.ADMIN, RoleHelper.SUPERADMIN] },

  static readonly routesRules: RoutesRules[] = [{ routepath: routeNames.home }];

  static canUserActivate(user: User, route: Route) {
    const routeRule = this.routesRules.find((r) => r.routepath === route.path);
    if (routeRule) {
      if (routeRule.forbiddenRoles && routeRule.forbiddenRoles.length > 0) {
        return this.hasNotRole(user, routeRule.forbiddenRoles);
      } else if (routeRule.allowedRoles && routeRule.allowedRoles.length > 0) {
        return this.hasAnyRole(user, routeRule.allowedRoles);
      } else {
        return true;
      }
    }
    return true;
  }

  static isSuperAdmin(user: User): boolean {
    return user.role !== null && user.isSuperAdmin();
  }

  static hasAnyRole(user: User, rolesList: string[]) {
    return user.role && rolesList.includes(user.role.code.toUpperCase());
  }

  static hasNotRole(user: User, rolesList: string[]) {
    return user.role && !rolesList.includes(user.role.code.toUpperCase());
  }
}
